'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import ServiceTabs from './components/ServiceTabs';
import BookingForm from './components/BookingForm';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/lib/translations';

export default function ServicesPage() {
  const { currentLang } = useLanguage();

  return (
    <>
      <Header currentLang={currentLang} />
      <main className="pt-40 pb-32 px-6 md:px-10 max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-16 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.4em] text-muted-foreground mb-4">
            {t('services.title', currentLang)}
          </p>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tighter mb-6">
            {t('services.hero', currentLang)}
          </h1>
        </div>

        {/* Service Tabs */}
        <ServiceTabs currentLang={currentLang} />

        {/* Booking Section */}
        <section id="booking" className="mt-32">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Booking Form */}
            <div>
              <h2 className="text-3xl font-bold tracking-tighter mb-8">
                {t('services.booking.title', currentLang)}
              </h2>
              <BookingForm currentLang={currentLang} />
            </div>

            {/* Testimonials */}
            <div>
              <h3 className="text-2xl font-bold tracking-tighter mb-8">
                {t('services.testimonials.title', currentLang)}
              </h3>
              <TestimonialsCarousel currentLang={currentLang} />
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="mt-32 text-center">
          <div className="max-w-2xl mx-auto space-y-6">
            <h3 className="text-3xl font-bold tracking-tighter">
              {t('services.cta.title', currentLang)}
            </h3>
            <p className="text-lg text-muted-foreground">
              {t('services.cta.description', currentLang)}
            </p>
            <a href="#booking" className="btn-primary inline-block">
              {t('services.cta.button', currentLang)}
            </a>
          </div>
        </section>
      </main>
      <Footer currentLang={currentLang} />
    </>
  );
}